import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';
import { until } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'StaticPage',
  setup(__props) {

const routingStore = useRoutingStore();
const userStore = useUserStore();

onMounted(async () => {
	await routingStore.urlMetadataPromise;
	await until(() => userStore.jwId).toBeTruthy({ timeout: 500 });

	if (routingStore.urlMetadata?.htmlContentJson?.script) {
		// there is some JS written up in the static page targetting elements that no longer exist (old design?)
		// ie: https://intranet.justwatch.com/dashboards/panel/cms/pages/42/en_US
		// It's in every country/locale and changing it is a whole thing so for now I ignore the error
		try {
			new Function(routingStore.urlMetadata.htmlContentJson.script)?.();
		} catch {}
	}
});

const htmlContent = computed(() => {
	const htmlContent = routingStore.urlMetadata?.htmlContentJson;
	return (htmlContent?.default || htmlContent?.compile || '').replace(
		new RegExp('{{BEST_EFFORT_ID}}', 'g'),
		userStore.bestEffortId
	);
});

const pageType = computed(() => {
	if (routingStore.urlMetadata?.metaTitle === 'TV Code') {
		return 'tvcode';
	}

	return routingStore.urlMetadata?.htmlContentJson?.landing_page_type || 'static';
});

return { __sfc: true,routingStore, userStore, htmlContent, pageType }
}

})